import React, { Component, useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { api, consts, get, post, put, getUser, getBranchOwner } from "@config";
import ImportCertificate from './importCertificate'

import defaultUnits from "../../products/utils/default-units";
import { BranchTour } from "@tours";
import CreateBranchHelper from '../../../tutorials/create_branch/index'

import { BranchType, BranchInfo } from "./steps";
import Address from "@parts/address-component"

import { getBranches } from "../../../../api/branches"

import PersonModel from "@models/person"
const branch = new PersonModel()



import AddressModel from "@models/address"
const address = new AddressModel()

import { setPersonType } from "@parts/person-type-component/actions";
import { setCreateNewBranchStep } from "./steps/actions";
import { setLoading } from "@inspinia-react/actions";

import {
  setBasePersonName,
  setBasePersonEmail,
  setBasePersonPhoneNumber
} from '@parts/base-person/actions'
import {
  setPostalCode,
  setStreet,
  setStreetNumber,
  setComplement,
  setDistrict,
  setStateLocation,
  setCityLocation
} from '@parts/address-component/actions'

import {
  setBranchIsFiscal
} from './steps/actions'
import { getAllBranches } from "../../../../sources/config";
import { setCookieByName } from "../../../../utils";

const user = getUser();
//const basic = lang.pages.create_branch.labels;
class CreateBranch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openTour: false,
      firstBranch: false,
      step: 0,
      changeIndividualToCompany: false
    };
    this.moveNextStep = this.moveNextStep.bind(this);
    this.moveToStep = this.moveToStep.bind(this);
    this._requestError = this._requestError.bind(this);
    this.onClickBuyCertificate = this.onClickBuyCertificate.bind(this)
  }
  onFinalizeTour() {
    put(
      `${api.users.register}${user.id}/`,
      {
        create_branch_tour: true,
        email: user.email,
        timezone: "America/Belem"
      },
      resp => {
        window.localStorage.setItem(consts.USER_DATA, JSON.stringify(resp));
      }
    );
  }

  setConfig(branch) {
    this.props.setLoading(true);
    toast.info("Realizando os ajustes finais...");
    defaultUnits.forEach(unit => {
      post(`${api.products.units}?branch_owner=${branch.id}`, unit, null);
    });
    if (this.state.firstBranch) {
      toast.success("Parabéns! Vocẽ criou sua primeira filial!");
    }
    const newCategoryPayload = _ => {
      if (this.props.isFiscal) {
        setTimeout(() => (window.location.href = "/digital-certificate"), 1200);
      } else {
        setTimeout(() => (window.location.href = "/plans/select"), 1200);
      }
    };
    post(
      `${api.products.categories}?branch_owner=${branch.id}`,
      { name: "Sem Categoria" },
      newCategoryPayload
    );
    setTimeout(() => {
      this.props.setLoading(false);
    }, 2500);
  }

  update() {
    const payload = branch => {
      window.localStorage.setItem(consts.CURRENT_BRANCH, JSON.stringify(branch))
      window.clientAPI._setCookie('branch_owner_id', branch.id)
      window.clientAPI._setCookie('branch_state_name', branch.address.state)
      window.location.href = '/settings/branch'
    }

    const errorPayload = error => {
      this.props.setLoading(false)
    }

    this.props.setLoading(true)

    const data = {
      name: this.props.name,
      phone_number: this.props.phoneNumber,
      email: this.props.email,
      company: {
        fancy_name: this.props.fancyName,
        cnpj: this.props.doc,
        state_registry: this.props.stateRegistry,
        main_cnae: this.props.cnae
      },
      branch: {
        main_company: true,
        crt: this.props.crt.crt.code,
        crt_description: this.props.crt.crt.description,
        is_fiscal: this.props.isFiscal,
        aliquota_credito: 1
      },
      address: {
        street: this.props.street,
        street_number: this.props.streetNumber,
        complement: this.props.complement,
        district: this.props.district,
        postal_code: this.props.postalCode,
        city_location: this.props.cityLocation.id,
        state_location: this.props.stateLocation.id
      }
    }

    const branchOwner = getBranchOwner().id

    const url = `${api.branches}${branchOwner}/`
    put(url, data, payload, errorPayload)

  }
  _requestError(error) {
    this.props.setLoading(false)

    if (error.status === 400) {
      const response = JSON.parse(error.response)

      if (response.cnpj_error) {
        this.props.setCreateNewBranchStep(1)
        toast.error(<h3 class="lead">Este CNPJ Já está cadastrado</h3>, {
          toastId: 901
        })
      } else if (response.cpf_error) {
        this.props.setCreateNewBranchStep(1)
        toast.error(<h3 class="lead">Este CPF Já está cadastrado</h3>, {
          toastId: 901
        })
      }

    }
  }

  create() {

    const data = {
      name: this.props.name,
      phone_number: this.props.phoneNumber,
      email: this.props.email,
    }
    data.branch = {
      aliquota_credito: 1,
      is_fiscal: this.props.isFiscal,
      branch_type: this.props.type + 1
    }
    if ([0, 3].includes(this.props.type)) {
      data.branch.main_company = false;
      data.branch.crt = 1
      data.individual = {
        cpf: this.props.doc
      }
    } else {
      if (!this.props.crt) {
        alert("INFORME O CRT NA ÁREA DE INFORMAÇÕES DA EMPRESA!")
        return
      }
      data.branch.crt = this.props.crt.crt.code
      data.branch.crt_description = this.props.crt.crt.description
      data.branch.main_company = true
      data.company = {
        fancy_name: this.props.fancyName,
        cnpj: this.props.doc,
        state_registry: this.props.stateRegistry,
        municipal_registry: this.props.municipalRegistry,
        main_cnae: this.props.cnae,
      }
    }

    data.address = address.data
    this.props.setLoading(true)
    let branches = window.localStorage[consts.ALL_BRANCHES]
    branches = branches ? JSON.parse(branches) : []
    const payload = async resp => {
      if (this.state.firstBranch) {
        this.onFinalizeTour();
      }
      branches.push(resp)
      getBranches()
        .then((response) => {
          const activeBranches = response.filter(branch => branch.status !== 2)
          setCookieByName("branch_count", activeBranches.length);
        })

      window.localStorage.removeItem(consts.ALL_BRANCHES);
      window.localStorage.setItem(consts.ALL_BRANCHES, JSON.stringify(branches));

      window.localStorage.removeItem(consts.CURRENT_BRANCH);
      window.localStorage.setItem(consts.CURRENT_BRANCH, JSON.stringify(resp));
      window.clientAPI._setCookie('branch_owner_id', resp.id)
      window.clientAPI._setCookie('branch_state_name', resp.address.state)
      window.clientAPI._setCookie('branch_owner_name', resp.individual ? resp.name : resp.company.fancy_name)
      this.setConfig(resp);
    };
    post(api.branches, data, payload, this._requestError);
  }

  tourFinalizedByUser() {
    this.props.setCreateNewBranchStep(0);
    this.setState({ ...this, openTour: false });

    put(`${api.users.register}${user.id}/`, {
      create_branch_tour: true,
      create_product_tour: false,
      email: user.email,
      timezone: "America/Belem"
    },
      resp => {
        window.localStorage.setItem(consts.USER_DATA, JSON.stringify(resp));
        this.setState({ ...this, openTour: false });
      }
    );
  }

  moveToStep(step) {
    this.props.setCreateNewBranchStep(step);
  }

  moveNextStep() {
    const { step, type } = this.props;
    branch.model = "branch"
    branch.type = type
    branch.initFromProps(this.props)
    address.data.street = this.props.street
    address.data.street_number = this.props.streetNumber
    address.data.complement = this.props.complement
    address.data.district = this.props.district
    address.data.postal_code = this.props.postalCode
    address.data.city_location = this.props.cityLocation.value
    address.data.state_location = this.props.stateLocation.value
    address.validate()

    switch (step) {
      case 0:
        this.props.setCreateNewBranchStep(1)
        break
      case 1:
        !branch.basePersonIsValid ? branch.showBasePersonNotificationErrors(true) : null
        if (branch.basePersonIsValid && branch.branchIsValid) {
          this.props.setCreateNewBranchStep(2)
        }
        break
      case 2:
        !address.isValid ? address.showNotificationErrors() : null
        if (address.isValid) {
          this.state.changeIndividualToCompany
            ? this.update()
            : this.create()
        }
    }
  }
  movePreviousStep() {
    const { step, type } = this.props;
    if (type === 0) {
      this.props.setCreateNewBranchStep(0);
    } else {
      this.props.setCreateNewBranchStep(step - 1);
    }
  }

  onClickBuyCertificate() {
    const url = `${api.users.find}buy-certificate-click/`;
    const payload = (resp) => {
      setTimeout(() => {
        window.open("http://bit.ly/comprar-certificad-eg-web-up", "_brank");
      }, 1000);
    };
    const errorPayload = (resp) => console.log(resp)

    get(url, payload, errorPayload);
  }

  UNSAFE_componentWillMount() {
    const user = JSON.parse(window.localStorage[consts.USER_DATA]);

    if (window.location.href.search('change-individual-to-company') > 0) {
      const branch = getBranchOwner()
      this.props.setCreateNewBranchStep(1);
      const { address } = branch

      this.props.setBasePersonName(branch.name)
      this.props.setBasePersonEmail(branch.email)
      this.props.setBasePersonPhoneNumber(branch.phone_number)
      this.props.setPostalCode(address.postal_code)
      this.props.setStreetNumber(address.street_number)
      this.props.setStateLocation(address.state_id)
      this.props.setCityLocation(address.city_id)
      this.props.setComplement(address.complement)
      this.setState({ ...this, changeIndividualToCompany: true })
      this.props.setBranchIsFiscal(true)
      this.props.setPersonType(1);

    } else {
      this.props.setCreateNewBranchStep(0);
      this.props.setPersonType(1);
      const base = JSON.parse(window.localStorage.getItem("base"))
      if (base != null) {
        this.props.setBasePersonName(base.name)
        this.props.setBasePersonEmail(base.email)
        this.props.setBasePersonPhoneNumber(base.phone_number)

        window.localStorage.removeItem("base")
      }
    }


    if (!user.create_branch_tour) {
      this.setState({
        ...this,
        firstBranch: true,
        openTour: true
      });
    } else if (!user.create_product_tour) {
    }
  }
  render() {
    return (
      <div className="container mb-2 py-3" id="create-new-branch">
        <div class="d-flex flex-row-reverse">
          <CreateBranchHelper />
        </div>
        <HeaderContent
          step={this.props.step}
          navigateTo={i => this.props.setCreateNewBranchStep(i)}
          steps={['Tipo', 'Informações', 'Endereço']}
        />
        <BodyContent step={this.props.step} type={this.props.type} />
        {
          this.props.type != 0 && this.props.step === 0 ? <ImportCertificate /> : <div />
        }
        <StepControls
          step={this.props.step}
          next={e => { this.moveNextStep() }}
          previous={e => { this.movePreviousStep() }}
        />
        {
          this.props.step === 0 ? [
            <p
              onClick={() => window.open("https://otimizeseunegocio.com/gestao-organizacao/certificado-digital-para-mei/", "_blank")}
              style={{ color: "#48a0dc", cursor: "pointer" }}
              className="lead text-center"
            >
              O que é Certificado Digital <i className="fas fa-question" />
            </p>,
            <p
              onClick={this.onClickBuyCertificate}
              style={{ color: "#48a0dc", cursor: "pointer" }}
              className="lead text-center"
            >
              Comprar Certificado Digital
            </p>
          ] : <div />
        }
      </div>
    );
  }
}
function HeaderContent(props) {

  const md = 12 / props.steps.length

  function navigateToStep(i) {
    props.navigateTo(i)
  }

  return <div className="row">
    {
      props.steps.map((step, i) => <div className={`col-md-${md} mx-auto`}>
        <h4
          onClick={() => navigateToStep(i)}
          className="text-center">
          <span className={`btn ${props.step === i ? "active btn-primary" : "btn "}`}>{step}</span>
        </h4>
      </div>)
    }
    <div className="col-12">
      <hr
        style={{
          marginTop: '-10px',
          maxWidth: '74%',
          zIndex: 'auto',
        }}
      />
    </div>

  </div>
}
function BodyContent(props) {
  let currentStepcomponent = null

  switch (props.step) {
    case 0:
      currentStepcomponent = <BranchType label="Eu sou .." />
      break;
    case 1:
      currentStepcomponent = <BranchInfo />
      break;

    case 2:
      currentStepcomponent = <Address viacep unavailableStates={props.type == 2} />
      break;
  }

  return <div className="row">
    <div className="col-md-12 h-100">
      {currentStepcomponent}
    </div>
  </div>
}

function StepControls(props) {
  const { previous, next } = props

  return <div className="row mb-5 mt-5">
    <div className="col-md-12">
      <div className="d-flex justify-content-between">
        {props.step !== 0
          ? <button
            onClick={previous}
            className="btn btn-danger w-100 mr-1">
            Anterior
          </button>
          : null}
        <button
          style={
            props.step === 0 ? {
              padding: 15,
              border: "none",
              borderRadius: 20,
              backgroundColor: "#cfefff",
              color: "#48a0dc",
              fontSize: 19,
              fontWeight: 500,
              cursor: 'pointer'
            } : {}
          }
          onClick={next}
          className="btn btn-primary ml-1 col-6 mx-auto">
          {
            props.step === 0
              ? "Preencher Manualmente"
              : (props.step !== 2) ? "Próximo" : "Finalizar"
          }
        </button>
      </div>
    </div>
  </div>
}

const mapStateToProps = state => ({
  loading: state.loading,
  step: state.step,
  isFiscal: state.isFiscal,
  type: state.personType,
  name: state.basePersonName,
  email: state.basePersonEmail,
  phoneNumber: state.basePersonPhone,

  fancyName: state.fancyName,
  doc: state.personDoc,
  crt: state.crt,
  cnae: state.cnae,
  stateRegistry: state.stateRegistry,
  municipalRegistry: state.municipalRegistry,

  cityLocation: state.cityLocation,
  complement: state.complement,
  district: state.district,
  postalCode: state.postalCode,
  stateLocation: state.stateLocation,
  streetNumber: state.streetNumber,
  street: state.street
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLoading,
      setPersonType,
      setCreateNewBranchStep,

      setBasePersonName,
      setBasePersonEmail,
      setBasePersonPhoneNumber,

      setPostalCode,
      setStreet,
      setStreetNumber,
      setComplement,
      setDistrict,
      setStateLocation,
      setCityLocation,
      setBranchIsFiscal

    },
    dispatch
  );
connect(mapStateToProps, null)(BodyContent)
export default connect(mapStateToProps, mapDispatchToProps)(CreateBranch);



// WEBPACK FOOTER //
// ./src/components/pages/branches/create/index.jsx